import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'gatsby';
import { Container } from '../Grid';
import Icon from '../Icon';
import Image from '../Image';
import './styles.scss';

const Callout = ({ to, children, className, containerClassName, ...other }) => {
  const renderLink = () => (
    <Link to={to} className="callout__link">
      {renderChildren()}
    </Link>
  );

  const renderChildren = () => (
    <Container
      className={classNames('callout__container', containerClassName)}
      fullWidth
    >
      {children}
      {to && <Image className="callout__icon" filename="icon-arrow.svg"/>}
    </Container>
  );

  return (
    <aside className={classNames('callout', className)} {...other}>
      {to ? renderLink() : renderChildren()}
    </aside>
  );
};

Callout.defaultProps = {
  to: null,
};

Callout.propTypes = {
  /** A path to an internal page */
  to: PropTypes.string,
  /** A custom class name */
  className: PropTypes.string,
};

export default Callout;
